import { warnOnceInDevelopment } from 'apollo-utilities';
// This can be used to set defaults for shop.config.js
export function addMissingConfig(userConfig) {
    if (!userConfig.pathsWithNoAuthRequired) {
        userConfig.pathsWithNoAuthRequired = [
            '/login',
            '/reset-password',
            '/forgot-password'
        ];
    }
    if (!userConfig.loginPath) {
        warnOnceInDevelopment(`loginPath is not set in shop.config.js. Please set it to the login route used for your shop.` +
            `e.g. loginPath: '/login'`);
        userConfig.loginPath = '/login';
    }
    if (!userConfig.routes)
        userConfig.routes = {};
    const routeList = {
        search: '/search',
        signup: '/signup',
        login: '/login',
        stores: '/stores',
        store: '/store',
        tree: '/tree',
        myPages: '/my-pages',
        forgotPassword: '/forgot-password',
        resetPassword: '/reset-password'
    };
    Object.keys(routeList).forEach(key => {
        if (!userConfig.routes.hasOwnProperty(key))
            userConfig.routes[key] = { path: routeList[key] };
    });
    return withDeprecations(userConfig);
}
function withDeprecations(userConfig) {
    return Object.assign(Object.assign({}, userConfig), { deprecations: Object.assign({ 
            /** Remove in 6.0.0 */
            useOldProductVariants: true }, userConfig.deprecations) });
}
//# sourceMappingURL=addMissingConfig.js.map